import { render, staticRenderFns } from "./VipEntrance.vue?vue&type=template&id=4d294e54&"
import script from "./VipEntrance.vue?vue&type=script&lang=ts&"
export * from "./VipEntrance.vue?vue&type=script&lang=ts&"
import style0 from "./VipEntrance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports